import api from "../utils/api";
import { isGuid } from "../utils/string";
import { LOGOUT } from "./types";

const BASE_URL = "/accounts/journals/lines";

export const byAccount = ({
  accountUuid,
  page = 0,
  size = 10,
  order = "createdAt",
  direction = "DESC",
} = {}) => async (dispatch) => {
  try {
    if (!isGuid(accountUuid)) return { items: [], count: 0, success: true };
    const res = await api.get(`${BASE_URL}/account/${accountUuid}/p/${Number(page)}/s/${Number(size)}/o/${order}/${direction}`);
    return res.data;
  } catch (err) {
    dispatch({ type: LOGOUT });
  }
};

export const ledger = ({
  accountUuids = [],
  page = 0,
  size = 25,
  order = "entryDate",
  direction = "DESC",
} = {}) => async (dispatch) => {
  try {
    const accounts = Array.isArray(accountUuids)
      ? accountUuids.filter(isGuid).join(",")
      : "";
    const query = accounts ? `?accounts=${encodeURIComponent(accounts)}` : "";
    const res = await api.get(`${BASE_URL}/ledger/p/${Number(page)}/s/${Number(size)}/o/${order}/${direction}${query}`);
    return res.data;
  } catch (err) {
    dispatch({ type: LOGOUT });
  }
};

export const save = (payload = {}) => async (dispatch) => {
  try {
    const res = await api.post(BASE_URL, payload);
    return res.data;
  } catch (err) {
    dispatch({ type: LOGOUT });
  }
};
